module.exports = __webpack_public_path__ + "static/media/Althar_Credenciales.03255575.mp4";